import { Anchor, Stack } from '@mantine/core'
import { forwardRef } from 'react'
import { RenderCategory } from '.'
import CategoryComponent from './category'

const CategoryColumn = forwardRef(
    (
        {
            categories,
            path,
            onSelect,
            name,
            level,
        }: {
            categories?: RenderCategory[]
            path: string[]
            onSelect: (id: string) => void
            name: string
            level: number
        },
        ref: any,
    ) => {
        if (!categories || categories.length === 0)
            return (
                <div>
                    <Stack ref={ref}>
                        <Anchor
                            color="blue"
                            size="sm"
                            className="underline underline-offset-2"
                            onClick={(e) => e.stopPropagation()}
                            href={`/search?category=${path.join('/')}`}
                        >
                            Afficher les produits
                        </Anchor>
                    </Stack>
                </div>
            )

        return (
            <div
                className={`flex flex-col items-start w-max col-span-1 text-left gap-4 h-full`}
                ref={ref}
                >
                {!!categories.length &&
                    categories
                        ?.sort((a, b) =>
                            (a.data?.title || '').localeCompare(
                                b.data?.title || '',
                            ),
                        )
                        .map((category) => {
                            if (!category.data) return null

                            return (
                                <CategoryComponent
                                    key={category.data?.id}
                                    category={category.data}
                                    onSelect={onSelect}
                                />
                            )
                        })}
            </div>
        )
    },
)

CategoryColumn.displayName = 'CategoryColumn'

export default CategoryColumn
